let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bW2Ht")).then(() => parcelRequire('k7gBp'));